<template>
    <div class="card-body">
        <h5 class="card-title">Feel free to contact us anytime at +880-1715413113.</h5>
        <p>
            Or You may drop us a line, give us a call or send an email, choose what suits you the most.
            You'll always get a response within 48 hours.
        </p>
        <div class="position-relative row form-group">
            <label for="labelName" class="col-sm-2 col-form-label">
                Name
            </label>
            <div class="col-sm-10">
                <input id="labelName"
                       placeholder="Enter your name"
                       type="text"
                       class="form-control"
                       v-model="formData.name"
                />
                <span class="text-danger">
                    {{ $errorMessage(errors, 'name') }}
                </span>
            </div>
        </div>
        <div class="position-relative row form-group">
            <label for="labelEmail" class="col-sm-2 col-form-label">Email</label>
            <div class="col-sm-10">
                <input v-model="formData.email"
                       id="labelEmail"
                       placeholder="Enter email"
                       type="email"
                       class="form-control"
                />
                <span class="text-danger">
                    {{ $errorMessage(errors, 'email') }}
                </span>
            </div>
        </div>
        <div class="position-relative row form-group">
            <label for="labelMobile" class="col-sm-2 col-form-label">Mobile</label>
            <div class="col-sm-10">
                <input v-model="formData.mobile"
                       id="labelMobile"
                       placeholder="01XXXXXXXXX"
                       type="text" class="form-control"
                />
                <span class="text-danger">
                    {{ $errorMessage(errors, 'mobile') }}
                </span>
            </div>
        </div>
        <div class="position-relative row form-group">
            <label for="labelSubject" class="col-sm-2 col-form-label">Subject</label>
            <div class="col-sm-10">
                <input v-model="formData.subject"
                       id="labelSubject"
                       placeholder="Subject"
                       type="text"
                       class="form-control"
                />
                <span class="text-danger">
                    {{ $errorMessage(errors, 'subject') }}
                </span>
            </div>
        </div>
        <div class="position-relative row form-group">
            <label for="exampleText" class="col-sm-2 col-form-label">Message</label>
            <div class="col-sm-10">
                <textarea v-model="formData.description" id="exampleText" class="form-control"></textarea>
                <span class="text-danger">
                    {{ $errorMessage(errors, 'description') }}
                </span>
            </div>
        </div>
        <div class="position-relative row">
            <div class="col-sm-10 offset-sm-2">
                <button class="btn btn-danger" @click="showContactUsConfirm">
                    SEND MESSAGE
                </button>
            </div>
        </div>

        <modal name="confirm-button" classes="p-5" :adaptive="true" :width="300" :height="180">
            <div class="d-flex justify-content-center">
                Are you sure?
            </div>
            <div class="d-flex align-items-center justify-content-center pt-2">
                <button class="btn btn-danger" @click="submitContactUs" :disabled="loading">
                    Yes
                </button>
                <button class="btn btn-secondary ml-2" @click="hideModal">
                    No
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        name: "ContactUs",
        data() {
            return {
                formData: {},
                loading: false,
                errors: {},
            }
        },
        methods: {
            showContactUsConfirm() {
                this.errors = {};
                this.$modal.show('confirm-button');
            },
            hideModal() {
                this.$modal.hide('confirm-button');
            },
            submitContactUs() {
                this.loading = true;
                this.errors = {};
                window
                    .axios
                    .post('/api/contact', this.formData)
                    .then(({data}) => {
                        this.$toastr.s(data.message);
                        this.formData = {};
                    })
                    .catch(({response}) => this.errors = response.data.errors)
                    .finally(() => {
                        this.loading = false;
                        this.hideModal();
                    })
            }
        },
    }
</script>

<style scoped>

</style>